export default __webpack_public_path__ + "static/media/linkedin.a7ba9647.png";